// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledStatusIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	overflow: hidden;
	background-color: ${({ theme: { colors } }) => colors.grey};
	border: 1px solid transparent;

	${({ customMargin }) =>
		customMargin &&
		css`
			margin: ${customMargin};
		`}
`;

const ReadedStatusIcon = ({ srcAvatar, customMargin }) => {
	return (
		<StyledStatusIcon customMargin={customMargin}>
			<img
				style={{ width: "100%", height: "100%" }}
				src={srcAvatar}
			></img>
		</StyledStatusIcon>
	);
};

export default ReadedStatusIcon;
